import React from 'react'
import SearchPreviewPane from './SearchPreviewPane'

// Right-column preview on the search-results page. Hosts the same preview
// components as the dropdown but is driven by the currently-active result row
// rather than the highlighted suggestion. The container handles sticky
// positioning, height cap and the bottom fade gradient.
function SearchResultsPreviewPanel({ activeHit, activeKind }) {
  // Non-library active rows (nav / external) get the empty-state info card
  // instead of an empty panel. SearchPreviewPane treats anything that fails
  // shouldShowPreviewFor() as non-library, so we only forward the hit for
  // library kinds.
  const previewable = activeKind === 'set' ||
    activeKind === 'question' ||
    activeKind === 'repo' ||
    activeKind === 'folder'
  const suggestion = previewable ? activeHit : null
  return (
    <div className='searchResults-previewPanel'>
      <SearchPreviewPane suggestion={suggestion} showEmptyState />
      <div className='searchResults-previewPanel-fade' aria-hidden='true' />
    </div>
  )
}

export default SearchResultsPreviewPanel
